export default __webpack_public_path__ + "static/media/02-PRAJWAL S BANDI.2f604014.jpg";